import { useLang } from "../i18n/LanguageContext";

export default function SuccessScreen({ player, onNew }) {
  const { t } = useLang();
  return (
    <div
      data-testid="success-screen"
      className="rounded-2xl bg-[#161616] border border-[#252525] p-8 sm:p-12 text-center relative overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none opacity-50"
           style={{ background: "radial-gradient(circle at 50% 0%, rgba(232,85,154,0.18) 0%, transparent 60%)" }}/>
      <div className="relative">
        <div className="inline-flex w-24 h-24 rounded-full bg-[#e8559a]/15 border-2 border-[#e8559a] items-center justify-center text-5xl mb-6 animate-bounce-slow">
          ⚽
        </div>
        <h1 className="font-bebas text-5xl sm:text-6xl tracking-[0.15em] text-white mb-3">
          {t("success_title")}
        </h1>
        <p className="text-neutral-400 max-w-md mx-auto mb-6">
          {t("success_message")}
        </p>
        <div className="inline-flex items-center gap-3 rounded-xl bg-[#e8559a]/10 border border-[#e8559a]/30 px-5 py-3">
          <span className="text-xs uppercase tracking-[0.25em] text-[#e8559a]/80">
            {t("success_player")} #
          </span>
          <span className="font-bebas text-3xl text-[#e8559a] tracking-widest leading-none" data-testid="success-number">
            {player?.player_number}
          </span>
          <span className="text-white font-medium">
            {player?.first_name} {player?.last_name}
          </span>
        </div>
        <div className="mt-8">
          <button
            onClick={onNew}
            data-testid="new-registration-btn"
            className="text-sm text-[#e8559a] hover:text-[#c9407f] underline underline-offset-4 transition-colors"
          >
            {t("new_registration")}
          </button>
        </div>
      </div>
    </div>
  );
}
